import React from "react";
import Select from 'react-select';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Icon from "components/Varios/Icons.js";
import TooltipItem from "components/Varios/Tooltip.js";

//Otros Localizacion
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('ES', es)




export default class Datepicker extends React.Component {

    constructor(props) {
        super(props);
        this.referenciaDatePicker = React.createRef();
    }

    state = {
        date: (this.props.value ? new Date(this.props.value) : null),
        toogleClass: ""

    };

    handleChange = date => {
        this.setState(
            { date },
            (() => { this.props.onChange(date, this.props.name) })
        );
    };


    ToogleActive = () => {
        if (this.referenciaDatePicker.current !== null && this.referenciaDatePicker.current !== undefined) {
            console.log(this.referenciaDatePicker.current.input.click())
        }
    }

    defaultStylesIcon = {
        backgroundColor: "#FFC200"
    }




    render() {
        return (
            <div className="input-group">
                <DatePicker
                    ref={this.referenciaDatePicker}
                    className="form-control clickable"
                    selected={(this.props.value ? new Date(this.props.value) : null)}
                    onChange={date => this.handleChange(date)}
                    name={this.props.name}
                    id={this.props.id}
                    dateFormat={(this.props.dateFormat ? this.props.dateFormat : "dd/MM/yyyy")}
                    placeholderText={this.props.placeholder}
                    disabled={(this.props.disabled)}
                    showYearPicker={(this.props.dateFormat === "yyyy" ? true : false)}
                    minDate={this.props.min}
                    showDisabledMonthNavigation={this.props.showDisabledMonthNavigation}
                    maxDate={this.props.max}
                    filterDate={this.props.filter}
                    excludeDates={this.props.excludeDates}
                    customInput={<input style={ this.props.IboxStyles ? this.props.IboxStyles : { fontFamily: "Roboto", fontSize: "14px" }} className="no_autocomplete" autoComplete="off"></input>}
                    includeDates={this.props.includeDates}
                    dayClassName={this.props.dayClassName}
                    locale="ES"
                    autoComplete="off"
                    showMonthDropdown={this.props.monthdropdown}
                    useShortMonthInDropdown={this.props.monthdropdown}
                    showYearDropdown={this.props.showYearDropdown}
                    portalId={this.props.portalId ?? ""}
                    container="body"
                />
                <div className="input-group-append " style={this.props.Istyles ? this.props.Istyles : this.defaultStylesIcon}>
                    {/*<i className="fas fa-calendar-alt" aria-hidden="true"></i >*/}
                    <Icon kind="calendario" fill={this.props.IfillColor ? this.props.IfillColor : "#FFFFFF"} width={27} height={27} onClick={() => this.ToogleActive()} />
                </div>
                {/* <TooltipItem content={this.props.placeholder} id={this.props.id} /> */}
            </div>
        )

    }
}